import { render, staticRenderFns } from "./ServicosForm.vue?vue&type=template&id=9807b2dc&scoped=true&"
import script from "./ServicosForm.vue?vue&type=script&lang=js&"
export * from "./ServicosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9807b2dc",
  null
  
)

export default component.exports